module.exports = __webpack_public_path__ + "img/companydummy.9294ee53.png";